import { NavItemsMydash, NavItemsSolicitacoes } from "../componentes/navbar/ItemsRouter.jsx";
import LOGO_BI from "../assets/logo_bi.png";
import LOGO_WORKFLOW from "../assets/logo_workflow.png";

// Chaves dos aplicativos — as mesmas strings usadas na claim "aplicativos" do JWT (backend:
// JwtService.aplicativosPermitidos) e nas authorities APP_MYDASH/APP_MYDASH_SOLICITACOES.
export const APLICATIVOS = {
    MYDASH: "MYDASH",
    MYDASH_SOLICITACOES: "MYDASH_SOLICITACOES",
};

/**
 * Config central de cada aplicativo — único lugar que sabe "o que é" um aplicativo (menus, rota
 * inicial, identidade visual, e a quais rotas ele pertence). Evita espalhar `if (isSolicitacoes)`
 * pelos componentes: quem precisa de algo específico de app só consulta essa lista via
 * `useApp()`. Adicionar um novo aplicativo no futuro é só adicionar mais uma entrada aqui.
 */
export const APLICATIVOS_CONFIG = [
    {
        key: APLICATIVOS.MYDASH,
        nome: "MyDash",
        descricao: "Dashboards, BP, despesas e indicadores",
        icone: "fa fa-chart-line",
        img: LOGO_BI,
        rotaInicial: "/bi",
        // Qualquer rota que não pertença explicitamente a outro aplicativo cai aqui — é o app
        // "padrão"/guarda-chuva, preservando todas as URLs atuais sem precisar renomeá-las.
        pertenceARota: (pathname) => !pathname.startsWith("/solicitacoes"),
        navItems: NavItemsMydash,
    },
    {
        key: APLICATIVOS.MYDASH_SOLICITACOES,
        nome: "MyDash Solicitações",
        descricao: "Processos, aprovações, tarefas e solicitações",
        icone: "fa fa-clipboard-list",
        img: LOGO_WORKFLOW,
        rotaInicial: "/solicitacoes/inicio",
        pertenceARota: (pathname) => pathname.startsWith("/solicitacoes"),
        navItems: NavItemsSolicitacoes,
    },
];

const CHAVE_APLICATIVO_ATUAL = "mydash.aplicativoAtual";

export function configDoAplicativo(key) {
    return APLICATIVOS_CONFIG.find(app => app.key === key) || APLICATIVOS_CONFIG[0];
}

/** A partir da URL atual, qual aplicativo essa rota pertence — usado pra manter o Navbar em sincronia com deep links/refresh. */
export function aplicativoDaRota(pathname) {
    return APLICATIVOS_CONFIG.find(app => app.pertenceARota(pathname)) || APLICATIVOS_CONFIG[0];
}

/**
 * A partir do `user` decodificado do JWT (claim "aplicativos" — array real, ver JwtService no
 * backend), quais apps esse usuário pode acessar. Sem a claim (token antigo, emitido antes desta
 * mudança) libera os dois — não regride ninguém que já estava logado.
 */
export function aplicativosPermitidosDoUsuario(user) {
    if (!user?.aplicativos || !Array.isArray(user.aplicativos)) {
        return APLICATIVOS_CONFIG;
    }
    return APLICATIVOS_CONFIG.filter(app => user.aplicativos.includes(app.key));
}

/** Última escolha persistida, só se ainda for uma opção válida pra esse usuário agora. */
export function ultimoAplicativoValido(aplicativosPermitidos) {
    try {
        const salvo = localStorage.getItem(CHAVE_APLICATIVO_ATUAL);
        if (salvo && aplicativosPermitidos.some(app => app.key === salvo)) return salvo;
    } catch {
        // localStorage indisponível (modo privado etc.)
    }
    return null;
}

export function salvarAplicativoAtual(key) {
    try {
        localStorage.setItem(CHAVE_APLICATIVO_ATUAL, key);
    } catch {
        // localStorage indisponível — segue sem persistir
    }
}
